import AccountPlatformHome from 'features/accountPlatforms/pages/AccountPlatformHome/AccountPlatformHome';

export default AccountPlatformHome;
